"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dispatchUpdateUnscopeUser = void 0;
var tslib_1 = require("tslib");
var firestore_1 = require("firebase/firestore");
var createErrorAction_1 = require("../../actionCreators/createErrorAction");
var updateUnscopeUserClient_1 = require("../../functions/utilities/ref/update/updateUnscopeUserClient");
var description = 'dispatchUpdateUnscopeUser';
var dispatchUpdateUnscopeUser = function (_a) { return tslib_1.__awaiter(void 0, [_a], void 0, function (_b) {
    var useDescription, error_1;
    var values = _b.values, parentDescription = _b.parentDescription, dispatch = _b.dispatch, userId = _b.userId;
    return tslib_1.__generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                useDescription = "".concat(parentDescription, " - ").concat(description);
                dispatch({
                    type: 'PATCH_UNSCOPE_USER_REQUEST',
                    description: useDescription,
                    requestValues: {
                        item: values,
                        params: {
                            userId: userId,
                        },
                    },
                });
                _c.label = 1;
            case 1:
                _c.trys.push([1, 5, , 6]);
                if (!(userId && values)) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, updateUnscopeUserClient_1.updateUnscopeUserClient)({
                        firestore: (0, firestore_1.getFirestore)(),
                        userId: userId,
                        unscopeUser: values,
                    })];
            case 2:
                _c.sent();
                dispatch({
                    type: 'PATCH_UNSCOPE_USER_SUCCESS',
                    description: useDescription,
                    requestValues: {
                        item: values,
                        params: {
                            userId: userId,
                        },
                    },
                    successValues: {
                        item: values,
                        params: {
                            userId: userId,
                        },
                    },
                });
                return [3 /*break*/, 4];
            case 3:
                dispatch((0, createErrorAction_1.createErrorAction)({
                    description: useDescription,
                }));
                _c.label = 4;
            case 4: return [3 /*break*/, 6];
            case 5:
                error_1 = _c.sent();
                dispatch((0, createErrorAction_1.createErrorAction)({
                    error: error_1,
                    description: "".concat(useDescription, " - try"),
                }));
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}); };
exports.dispatchUpdateUnscopeUser = dispatchUpdateUnscopeUser;
